var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-[env(safe-area-inset-bottom)]",
    },
    [
      _c("navBar", { attrs: { title: _vm.$t("badges.title") } }),
      _vm.cur.level !== 5
        ? _c(
            "div",
            {
              staticClass:
                "mx-4 mt-3 bg-white rounded-2xl p-6 shadow-sm border border-gray-200",
            },
            [
              _c(
                "div",
                { staticClass: "flex items-start justify-between gap-4 mb-4" },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col items-center flex-1" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-24 h-24 rounded-full flex items-center justify-center",
                        },
                        [
                          _c("img", {
                            staticClass: "w-full h-full object-cover",
                            attrs: {
                              src: _vm.imageBaseUrl + _vm.cur.icon,
                              alt: "cur",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "text-xl font-bold text-gray-800" },
                        [_vm._v(_vm._s(_vm.curPoint))]
                      ),
                      _c("div", { staticClass: "text-red-600 text-lg" }, [
                        _vm._v("▲"),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center flex-1 justify-start pt-10",
                    },
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "text-xs text-gray-600 text-center mt-6",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("badges.needPoints")) +
                              " " +
                              _vm._s(_vm.diffPoint) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " " + _vm._s(_vm.$t("badges.canUpgrade")) + " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex flex-col items-center flex-1" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-24 h-24 rounded-full flex items-center justify-center",
                        },
                        [
                          _c("img", {
                            staticClass: "w-full h-full object-cover",
                            attrs: {
                              src: _vm.imageBaseUrl + _vm.next.icon,
                              alt: "next",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "text-xl font-bold text-gray-800" },
                        [_vm._v(_vm._s(_vm.next.point))]
                      ),
                      _c("div", { staticClass: "text-red-600 text-lg" }, [
                        _vm._v("▲"),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex items-end justify-between gap-4" },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col items-center flex-1" },
                    [
                      _c(
                        "div",
                        { staticClass: "text-xs text-gray-600 text-center" },
                        [_vm._v(_vm._s(_vm.$t("badges.currentLevel")) + ": ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text-xs text-gray-600 text-center mb-2",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.isZh ? _vm.cur.name : _vm.cur.nameEn)
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "flex-1" }),
                  _c(
                    "div",
                    { staticClass: "flex flex-col items-center flex-1" },
                    [
                      _c(
                        "div",
                        { staticClass: "text-xs text-gray-600 text-center" },
                        [_vm._v(_vm._s(_vm.$t("badges.nextLevel")) + ":")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "text-xs text-gray-600 text-center mb-2",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.isZh ? _vm.next.name : _vm.next.nameEn)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.cur.level === 5
        ? _c(
            "div",
            {
              staticClass:
                "mx-4 mt-3 bg-white rounded-2xl p-6 shadow-sm border border-gray-200",
            },
            [
              _c(
                "div",
                { staticClass: "flex items-start justify-between gap-4 mb-4" },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col items-center flex-1" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-24 h-24 rounded-full flex items-center justify-center",
                        },
                        [
                          _c("img", {
                            staticClass: "w-full h-full object-cover",
                            attrs: {
                              src: _vm.imageBaseUrl + _vm.cur.icon,
                              alt: "cur",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "text-xl font-bold text-gray-800" },
                        [_vm._v(_vm._s(_vm.curPoint))]
                      ),
                      _c("div", { staticClass: "text-red-600 text-lg" }, [
                        _vm._v("▲"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "text-xs text-gray-600 text-center mt-2",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("badges.currentLevel")) +
                              ": " +
                              _vm._s(_vm.cur.name)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "mt-7 w-full overflow-hidden mb-6 text-xs" }, [
        _c(
          "table",
          {
            staticClass: "w-full rounded-xl overflow-hidden shadow-sm",
            staticStyle: { "table-layout": "fixed" },
          },
          [
            _c("thead", { staticClass: "bg-gray-100" }, [
              _c(
                "tr",
                {},
                [
                  _c(
                    "th",
                    {
                      staticClass:
                        "px-1 py-2 font-bold text-gray-800 md:text-xs text-[11px] w-20%",
                      staticStyle: { "vertical-align": "bottom" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("badges.benefit")) + " ")]
                  ),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "th",
                      {
                        key: "table-" + index,
                        staticClass:
                          "px-1 py-2 font-bold text-gray-800 md:text-xs text-[11px] w-20%",
                        staticStyle: { "vertical-align": "bottom" },
                      },
                      [
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _c("img", {
                            staticClass:
                              "w-10 h-10 object-cover rounded-full mx-auto",
                            attrs: {
                              src: _vm.imageBaseUrl + badge.icon,
                              alt: badge.name,
                            },
                          }),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.isZh ? badge.name : badge.nameEn)
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
            _c("tbody", { staticClass: "bg-white" }, [
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("img", {
                      staticClass: "w-4 h-4 inline-block",
                      attrs: { src: _vm.YoyoCoinsSrc, alt: "Yoyo Coins" },
                    }),
                    _vm._v(" " + _vm._s(_vm.$t("badges.points")) + " "),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "points-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [_c("div", {}, [_vm._v(_vm._s(badge.point))])]
                    )
                  }),
                ],
                2
              ),
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("badges.consumeRM1")))]),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "consume-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [
                        _c("div", {}, [
                          _vm._v(_vm._s(badge.pointTradeGivePoint || "-")),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("badges.birthdayBenefit"))),
                    ]),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "birthday-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [
                        _c("div", {}, [
                          _vm._v(_vm._s(badge.birthdayPoint || "-")),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("badges.exclusiveBenefit"))),
                    ]),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "welfare-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [
                        badge.welfare
                          ? _c("img", {
                              staticClass: "w-5 h-5 inline-block",
                              attrs: { src: _vm.rightSrc, alt: "right" },
                            })
                          : _c("span", { staticClass: "text-gray-300" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("badges.yoyoCoinValid")))]),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "pointLong-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [
                        badge.pointLong
                          ? _c("img", {
                              staticClass: "w-5 h-5 inline-block",
                              attrs: { src: _vm.rightSrc, alt: "right" },
                            })
                          : _c("span", { staticClass: "text-gray-300" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("div", [_vm._v(_vm._s(_vm.$t("badges.freeShipping")))]),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "postFree-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [
                        badge.postFree
                          ? _c("img", {
                              staticClass: "w-5 h-5 inline-block",
                              attrs: { src: _vm.rightSrc, alt: "right" },
                            })
                          : _c("span", { staticClass: "text-gray-300" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "tr",
                { staticClass: "text-center border-b border-gray-100" },
                [
                  _c("td", { staticClass: "px-1" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("badges.customerService"))),
                    ]),
                  ]),
                  _vm._l(_vm.badges, function (badge, index) {
                    return _c(
                      "td",
                      {
                        key: "postFree-" + index,
                        staticClass:
                          "px-1 py-4 text-xs text-gray-800 text-center",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.isZh ? badge.kfSer : badge.kfSerEn) +
                            " "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex items-center gap-1 mb-2" }, [
      _c("span", { staticClass: "w-2 h-1 bg-orange-500 rounded-full" }),
      _c("span", { staticClass: "w-2 h-1 bg-orange-500 rounded-full" }),
      _c("span", { staticClass: "w-2 h-1 bg-orange-500 rounded-full" }),
      _c("span", { staticClass: "w-2 h-1 bg-orange-500 rounded-full" }),
      _c("span", { staticClass: "w-2 h-1 bg-orange-500 rounded-full" }),
      _c("span", { staticClass: "text-orange-500 text-sm" }, [_vm._v("▶")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }